import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (pathname === "/") {
      const hasReloaded = sessionStorage.getItem('hasReloadedRoot');
      if (!hasReloaded) {
        sessionStorage.setItem('hasReloadedRoot', 'true');
        window.location.reload();
      }
    } else {
      sessionStorage.removeItem('hasReloadedRoot');
    }
  }, [pathname]);

  return null;
}